module.exports = __webpack_public_path__ + "c44cde7d2126f42d0578f53ca7957e1c.png";